import React, { useState } from "react";
import JourneyPlaceSections from "../builder/JourneyPlaceSections";
import { placeTitle } from "../builder/journeyBuilderModel";

// A stop's details, opened under it on the Update Journey timeline ("View
// Visit"): the same section tabs and forms as Add / Edit Journey — Visit Info,
// Book Distribution, Accommodation, Media & Advice, Public Response — saved
// through the API as they are changed. Opens on Visit Info.
export default function JourneyStopDetails({ place, usePlaceStore, perms, range, bookCatalog }) {
  const [activeTab, setActiveTab] = useState(perms.tabs[0] || null);
  return (
    <div className="tsp-city-detail tsp-city-place-details">
      <JourneyPlaceSections
        place={place}
        idBase={`ju-${place.key}`}
        title={placeTitle(place)}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        usePlaceStore={usePlaceStore}
        perms={perms}
        range={range}
        bookCatalog={bookCatalog}
      />
    </div>
  );
}
